function areaCreateRules(app) {
  return {

    // オーナー名 チェック  ・桁数チェック  ・必須チェック  ・型チェック
    ownerName: [
      {
        required: true,
        trigger: 'change',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.area.create.ownerName')
        })
      },
      {
        max: 50,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.area.create.ownerName'),
          length: 50
        })
      }
    ],

    // ビル名 チェック  ・桁数チェック  ・必須チェック  ・型チェック
    buildingName: [
      {
        required: true,
        trigger: 'change',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.area.create.buildingName')
        })
      },
      {
        max: 50,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.area.create.buildingName'),
          length: 50
        })
      }
    ],

    // フロア チェック  ・桁数チェック  ・必須チェック
    floorName: [
      {
        required: true,
        trigger: 'change',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.area.create.floorName')
        })
      },
      {
        max: 50,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.area.create.floorName'),
          length: 50
        })
      }
    ],

    // エリア名 チェック  ・桁数チェック  ・必須チェック  ・型チェック
    areaName: [
      {
        required: true,
        trigger: 'change',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.area.create.areaName')
        })
      },
      {
        max: 50,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.area.create.areaName'),
          length: 50
        })
      }
    ],

    // エリア区分 ・必須チェック
    areaType: [
      {
        required: true,
        trigger: 'change',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.area.create.areaType')
        })
      }
    ],

  }
}

export default {
  areaCreateRules: areaCreateRules
}
